/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_Add_Weight_Birth_YearInputs */

const en_ui_more_stats_add_weight_birth_year = /** @type {(inputs: Ui_More_Stats_Add_Weight_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add weight & birth year`)
};

const de_ui_more_stats_add_weight_birth_year = /** @type {(inputs: Ui_More_Stats_Add_Weight_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht & Geburtsjahr eintragen`)
};

/**
* | output |
* | --- |
* | "Add weight & birth year" |
*
* @param {Ui_More_Stats_Add_Weight_Birth_YearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_add_weight_birth_year = /** @type {((inputs?: Ui_More_Stats_Add_Weight_Birth_YearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Add_Weight_Birth_YearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_add_weight_birth_year(inputs)
	return de_ui_more_stats_add_weight_birth_year(inputs)
});